import { FontAwesome5 } from '@expo/vector-icons';
import { styled } from '@openeducation/oe-rn-themes';
import React from 'react';

import { RecordingBar } from './recording-bar';

export interface RecordButtonProps {
  isLoading?: boolean;
  isRecording?: boolean;
  hasRecording?: boolean;
  showAnimation?: boolean;
  disabled?: boolean;
  onPress?: () => void;
}

export const RecordButton = ({
  isLoading = false,
  isRecording = false,
  hasRecording = false,
  showAnimation = false,
  disabled = false,
  onPress,
}: RecordButtonProps) => {
  const ranges: [number, number][] = [
    [5, 15],
    [15, 30],
    [25, 35],
    [35, 40],
  ];

  return (
    <Container>
      {showAnimation &&
        isRecording &&
        ranges.map((range, index) => (
          <RecordingBar key={index} range={range} />
        ))}

      <Button
        disabled={isLoading || disabled}
        isLoading={isLoading}
        isRecording={isRecording}
        onPress={onPress}
      >
        {isLoading ? (
          <StyledActivityIndicator size={24} />
        ) : (
          <StyledIcon
            size={24}
            name={hasRecording ? 'undo' : isRecording ? 'stop' : 'microphone'}
          />
        )}
      </Button>

      {showAnimation &&
        isRecording &&
        ranges
          .reverse()
          .map((range, index) => <RecordingBar key={index} range={range} />)}
    </Container>
  );
};

const Container = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

interface ButtonProps {
  isRecording: boolean;
  isLoading: boolean;
}

const Button = styled.Pressable<ButtonProps>`
  background-color: ${({ theme, isRecording, isLoading }) =>
    isRecording || isLoading ? theme.color.error : theme.color.sunnyOrange};
  opacity: ${({ disabled }) => (disabled ? 0.8 : 1)};
  width: 80px;
  height: 80px;
  border-radius: 40px;
  align-items: center;
  justify-content: center;
`;

const StyledActivityIndicator = styled.ActivityIndicator.attrs(({ theme }) => ({
  color: theme.color.white,
}))``;

const StyledIcon = styled(FontAwesome5).attrs(({ theme }) => ({
  color: theme.color.white,
}))``;
